import React, { Component } from 'react';
import {connect} from 'react-redux';
if (window.require != undefined) {
    var electron = window.require('electron');
}
class SaveFile extends Component {

    constructor(props) {
        super(props)
        this.handleSaveFile = this.handleSaveFile.bind(this)
    }
    handleSaveFile(){
        console.log(this.props)
        if(this.props.showtitle){
            this.props.saveProjectSb3().then((content)=>{
                content.arrayBuffer().then((data)=>{
                    let Obj = {
                        modifly:this.props.modifly,
                        projectTitle: this.props.projectTitle,
                        saveFilePath: this.props.saveFilePath,
                        content:new Uint8Array(data),
                    }
                    electron && electron.ipcRenderer.send('saveFile', Obj)
                })
            })
        }else{
            // python
            let Obj = {
                projectTitle: this.props.projectTitle,
                pythonModifly: this.props.pythonModifly,
                saveFilePath: this.props.savePythonPath,
                content:this.props.monacodeValue
            }
            electron && electron.ipcRenderer.send('save_python_File', Obj);
        }
    }
    render() {
        const {
            children
        } = this.props
        return children(
            this.handleSaveFile,
            <React.Fragment>
                {children}
            </React.Fragment>
        )
    }
}
const mapStateToProps = state => ({
    showtitle: state.scratchGui.menus.showtitle,
    modifly: state.scratchGui.menus.modifly,
    saveFilePath: state.scratchGui.menus.save_file_path,
    pythonModifly: state.scratchGui.menus.python_modifly,
    savePythonPath: state.scratchGui.menus.save_python_path,
    projectTitle: state.scratchGui.projectTitle.title,
    monacodeValue: state.scratchGui.monacodes.value,
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
})

const mapDispatchToProps = (dispatch, props) => ({
})
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveFile)
